// src/components/menuItems.js

import {
  faDashboard,
  faClipboard,
  faEnvelope, faExclamationTriangle,
  faUsers, faCalendarAlt, faQuoteRight,
  faBox, faProjectDiagram, faTools, faQuoteLeft,
  faBars, faWrench, faBuilding, faCog, faCoffee, faListCheck,
  faIdBadge, faList, faUserShield, faSitemap, faAddressBook
} from '@fortawesome/free-solid-svg-icons';


export const MenuItems = [

  {
    group: 'Dashboard',
    items: [
      {
        to: '/dashboard',
        icon: faDashboard,
        label: 'Dashboard',
      }

    ]
  },
  {
    group: 'Human Resource',
    items: [
      {
        to: '/humanresourcc',
        icon: faBox,
        label: 'HR Configuration',
        isDropdown: true,
        subItems: [
          {
            to: '/hr/department',
            icon: faBuilding,
            label: 'Department',
          },
          {
            to: '/hr/designation',
            icon: faIdBadge,
            label: 'Designation',
          }
        ],
      },

      {
        to: '/hr/employee',
        icon: faUsers,
        label: 'Employee',
      }

    ]
  },

  {
    group: 'Support',
    items: [
      {
        to: '/tickets',
        icon: faClipboard,
        label: 'Tickets',
      },
      // {
      //   to: '/tickets/admin/new-request',
      //   icon: faClipboard,
      //   label: 'Open Support Request',
      // },
      // {
      //   to: '/tickets/admin-created',
      //   icon: faClipboard,
      //   label: 'Admin Created Tickets',
      // },
      {
        to: '/tickets/reports/tickets',
        icon: faClipboard,
        label: 'Ticket Summary',
      },
      {
        to: '/tickets/reports/tickets-summary',
        icon: faClipboard,
        label: 'Tickets Summary',
      },
      {
        to: '/all-tasks',
        icon: faListCheck,
        label: 'All Task',
      },
      {
        to: '/my-tasks',
        icon: faListCheck,
        label: 'My Task',
      }
    ]
  },


  {
    group: 'Client',
    items: [
      {
        to: '/client/organization',
        icon: faSitemap,
        label: 'Organization',
      },
      {
        to: '/client/customer',
        icon: faAddressBook,
        label: 'Customer',
      },
      {
        to: '/client/customer-users',
        icon: faUsers,
        label: 'Customer Users',
      }
    ]
  },

  {
    group: 'User Permission',
    items: [
      {
        to: '/user/modules',
        icon: faBox,
        label: 'Modules',
      },

      {
        to: '/user/modules/menus',
        icon: faList,
        label: 'Module Menus',
      },
      {
        to: '/user/roles',
        icon: faUsers,
        label: 'Roles',
      },
      {
        to: '/user/alluser',
        icon: faUsers,
        label: 'All User',
      },
      {
        to: '/defultrole/menu/permissions',
        icon: faUserShield,
        label: 'Default Role Permissions',
      },
      {
        to: '/user/menu/permissions',
        icon: faUserShield,
        label: 'User Menu Permissions',
      }

    ]
  },

];
